import { render, staticRenderFns } from "./SingleImmo.vue?vue&type=template&id=a5117844"
import script from "./SingleImmo.vue?vue&type=script&lang=js"
export * from "./SingleImmo.vue?vue&type=script&lang=js"
import style0 from "./SingleImmo.vue?vue&type=style&index=0&id=a5117844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports